import SignIn from 'src/app/preauth/signin'
import Identification from 'src/app/preauth/forgotPassword/identification'
import PasswordReset from 'src/app/preauth/forgotPassword/passwordReset'

export default [
    SignIn,
    Identification,
    PasswordReset
]